import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1, ArticleHeading4 } from '@cian/ui-kit';
import { Rating as RatingComponent } from '../../components/Rating';
import { PieChart } from '../../components/PieChart';
import { IApplicationState } from '../../types/redux';
import { getDeveloperRatingById } from '../../selectors';
import { RatingLegend } from '../RatingLegend';
import { RatingDescription } from '../RatingDescription';

interface IRatingProps {
  ratingId: number;
}

export function Rating({ ratingId }: IRatingProps) {
  const rating = useSelector((state: IApplicationState) => getDeveloperRatingById(state, ratingId));

  if (!rating) {
    return null;
  }

  return (
    <RatingComponent
      chart={<PieChart data={rating} />}
      label={<ArticleHeading1>{rating.graph.label}</ArticleHeading1>}
      title={<ArticleHeading4>{rating.title}</ArticleHeading4>}
      description={
        <>
          <RatingDescription ratingId={ratingId} />
          <RatingLegend ratingId={ratingId} />
        </>
      }
    />
  );
}
